import React, { useState } from "react";
import { ModalStyle } from "../../../../../common/components/ModalStyle";
import { Box, Modal } from "@mui/material";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import { useForm } from "react-hook-form";
import InputField from "../../../../../common/components/FormFields/InputField";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CheckBoxField from "../../../../../common/components/FormFields/CheckBoxField";
import CommonDivider from "../../../../../common/components/divider/CommonDivider";

import { CapitalizeStatement } from "../../../../../common/components/Custom Hooks/CapitalizeStatement";
import {
  saveVisitorCompany,
  updateVisitorCompany,
} from "../../services/VisitorCompanyService";
import CancelPresentationIconButton from "../../../../../common/components/Buttons/CancelPresentationIconButton";
import {
  errorAlert,
  successAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  maxHeight: "90%",
  width: "35%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 20,
  // borderRadius: "10px",
  overflowY: "auto",
  p: 2,
};

const defaultValues = {
  visitorCompanyName: "",
  category: null,
  status: true,
};

function AddNewVisitorCompanyModal(props) {
  const {
    addNewVCompanyModal,
    setAddNewVCompanyModal,
    populateTable,
    setIsBackdrop,
    selectedRow,
    setSelectedRow,
  } = props;

  const schema = yup.object().shape({
    visitorCompanyName: yup.string().trim().required("Course Name is required"),
  });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [finalObject, setFinalObject] = useState(null);

  const handleSaveClick = (data) => {
    const tempObj = {
      id: selectedRow !== null ? selectedRow?.Id : null,
      companyName: CapitalizeStatement(data?.visitorCompanyName),
      isActive: data?.status,
    };
    setFinalObject(tempObj);
    setPostConfirmationModal(true);
  };

  const onSubmit = () => {
    setIsBackdrop(true);
    if (selectedRow === null) {
      saveVisitorCompany(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            reset(defaultValues);
            setAddNewVCompanyModal(false);
            populateTable();
            successAlert(res?.message);
            setIsBackdrop(false);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    } else {
      updateVisitorCompany(finalObject)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            reset(defaultValues);
            setAddNewVCompanyModal(false);
            populateTable();
            successAlert(res?.message);
            setIsBackdrop(false);
          } else {
            populateTable();
            errorAlert(res?.message);
            setIsBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setIsBackdrop(false);
        });
    }
    setPostConfirmationModal(false);
    setSelectedRow(null);
    setFinalObject(null);
  };
  React.useEffect(() => {
    if (selectedRow !== null) {
      setValue("visitorCompanyName", selectedRow?.["Company Name"]);
      setValue("status", selectedRow.Status);
    } else {
      reset(defaultValues);
    }
  }, [selectedRow]);
  console.log("selectedRow", selectedRow);
  return (
    <div>
      <Modal
        open={addNewVCompanyModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={ModalStyles} className="w-[60%] lg:w-[45%] p rounded-lg">
          <form
            onSubmit={handleSubmit(handleSaveClick)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(handleSaveClick)();
              }
            }}
          >
            <div className="flex justify-between items-center">
              <h1 className="text-lg font-semibold whitespace-nowrap  ">
                {selectedRow !== null ? "Update" : "New"} Visitor Company
              </h1>
              <CancelPresentationIconButton
                type={"button"}
                onClick={() => {
                  setAddNewVCompanyModal(false);
                  setSelectedRow(null);
                }}
              />
            </div>
            <div className="mb-3">
              {" "}
              <CommonDivider color="#E0E0E0" />
            </div>
            <div className="flex gap-2 items-center ">
              <InputField
                name="visitorCompanyName"
                label="Visitor Company Name *"
                type={"text"}
                control={control}
                error={errors.visitorCompanyName}
              />

              <CheckBoxField
                name="status"
                style={{ fontWeight: 500 }}
                control={control}
                label="Active"
              />

              <div className="flex gap-2  justify-end ">
                <CommonButton
                  label="Reset"
                  type="button"
                  className="resetButton bg-white text-customRed border border-customRed rounded px-4"
                  onClick={() => reset(defaultValues)}
                />
                <CommonButton
                  label={selectedRow !== null ? "Update" : "Save"}
                  type="submit"
                  className="saveButton bg-customGreen text-white rounded px-5"
                />
              </div>
            </div>
          </form>

          {postConfirmationModal && (
            <ConfirmationModal
              confirmationOpen={postConfirmationModal}
              confirmationHandleClose={() => setPostConfirmationModal(false)}
              confirmationSubmitFunc={onSubmit}
              confirmationMsg={`Are you sure you want to ${
                selectedRow === null ? "Add" : "Update"
              } this Record?`}
              confirmationButtonMsg={"Confirm"}
              confirmationLabel={"Confirmation"}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default AddNewVisitorCompanyModal;
